import React from "react"
import intl from "react-intl-universal"
import { wrapperInputCn, labelCn, inputAreaCn } from "../styles"
import AdditionalInfo from "./AdditionalInfo"

const MagicSelect = ({labelText, content, hasInfo, tooltipContent, name, onChange, selectedValue, disabled, isHalfWidth, otherValue, onOtherChange, showOtherInput, isLoading}: {labelText: string, content: [string, string][], hasInfo?: boolean, tooltipContent?: string, name: string, onChange: (e) => void, selectedValue?: string | number, disabled?: boolean, isHalfWidth?: boolean, otherValue?: string | number, onOtherChange?: (e) => void, showOtherInput?: boolean, isLoading?: boolean}) => {
  const isOtherSelected = selectedValue === 'other'

  return (
    <div className={`${wrapperInputCn} ${isHalfWidth ? 'sm:w-1/2' : 'sm:w-1/3'} ${isOtherSelected ? 'relative mb-10' : ''}`}>
      <div className={`${hasInfo && 'flex flex-row space-x-2'}`}>
        <label htmlFor={name} className={labelCn}>{labelText}</label>
        {hasInfo && <AdditionalInfo tooltipContent={tooltipContent || ''} />}
      </div>
      {isLoading ? (
        <div className="h-11 bg-gray-200 skeleton-box" />
      ) : (
        <select
          id={name}
          name={name}
          className={`${inputAreaCn} shadow-[0_0px_10px_0px_rgba(0,0,0,0.2)]`}
          value={selectedValue}
          disabled={disabled}
          onChange={onChange}>
          <option value="automatic">{intl.get('automatic')}</option>
          {content.map(([key, value], index) => {
            return <option value={key} key={`${key}-${index}`}>{value}</option>
          })}
        </select>
      )}
      {!isLoading && showOtherInput && isOtherSelected && onOtherChange && (
        <input
          name={`${name}Other`}
          id={`${name}Other`}
          type="number"
          min={1}
          max={20}
          placeholder="Enter number of sessions"
          className={`${inputAreaCn} shadow-[0_0px_10px_0px_rgba(0,0,0,0.2)} w-1/2 sm:w-[284px] absolute -bottom-10 left-4`}
          value={otherValue || ''}
          onChange={onOtherChange}
        />
      )}
    </div>
  )
}

export default MagicSelect